import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenProvider } from './token-provider';
import { mergeMap } from 'rxjs/operators';
import { TokenRefreshToken } from './models';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private tokenProvider: TokenProvider) {}
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //todo: add blacklist and make it configurable from outside the module
    if (req.url.indexOf('/api/authentication') > -1) {
      return next.handle(req);
    }
    return this.tokenProvider.getToken().pipe(
      mergeMap((tokenAndRefreshToken: TokenRefreshToken) => {
        if (!tokenAndRefreshToken) {
          return next.handle(req);
        }
        if (req.url.indexOf('/api/refreshauthentication') > -1) {
          return next.handle(req);
        }
        const authReq = req.clone({
          headers: req.headers.set('Authorization', 'Bearer ' + tokenAndRefreshToken.token),
        });
        return next.handle(authReq);
      })
    );
  }
}
